import { WalletController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { SubwalletInfo } from '../../pages';
import { observer } from 'mobx-react';
import { walletStore } from '../../stores';
import React, { useState } from 'react';
import * as yup from 'yup';

const SubwalletInfoContainer = ({ closeModal, wallet }) => {
	const [settings, setSettings] = useState(false);
	const [loading, setLoading] = useState(false);
	const [assignEmployee, setAssignEmployee] = useState(false);
	const [confirmDeactivation, setConfirmDeactivation] = useState(false);

	const showConfirmDeactivate = () => {
		setConfirmDeactivation(true);
	};
	const showSettings = () => {
		setSettings(true);
	};
	const showAssignEmployee = () => {
		setAssignEmployee(true);
	};
	const validationSchema = () => {
		return yup.object({
			name: yup.string().required('Name is required'),
			limit: yup
				.number()
				.required('Limit is required')
				.min(1, 'Limit is required'),
			limitPeriod: yup.string().required('Period is required'),
		});
	};

	const userValidationSchema = () => {
		return yup.object({
			action: yup.string().required('Action is required'),
			user: yup
				.string()
				.max(24)
				.min(24)
				.required('User is required')
				.min(1, 'Limit is required'),
		});
	};

	const removeSubwallet = async id => {
		setLoading(true);
		const { selectedSubWallet } = walletStore;
		const {
			status,
			errorMessage,
		} = await WalletController.deactivateSubWalletFund(selectedSubWallet._id);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		const { selectedSubWallet } = walletStore;
		const { status, errorMessage } = await WalletController.updateSubWallet(
			payload,
			selectedSubWallet._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	const onSubmitAssign = async payload => {
		setLoading(true);
		const { selectedSubWallet } = walletStore;
		const { status, errorMessage } = await WalletController.assignSubWallet(
			payload,
			selectedSubWallet._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const goBack = () => {
		if (settings) {
			setSettings(false);
		} else if (assignEmployee) {
			setAssignEmployee(false);
		} else if (confirmDeactivation) {
			setConfirmDeactivation(false);
		}
	};

	return (
		<SubwalletInfo
			closeModal={closeModal}
			settings={settings}
			showSettings={showSettings}
			onSubmit={onSubmit}
			onSubmitAssign={onSubmitAssign}
			loading={loading}
			userValidationSchema={userValidationSchema}
			validationSchema={validationSchema}
			assignEmployee={assignEmployee}
			showAssignEmployee={showAssignEmployee}
			goBack={goBack}
			removeSubwallet={removeSubwallet}
		/>
	);
};

export default observer(SubwalletInfoContainer);
